import React from 'react';
import { DragDropContext } from '@hello-pangea/dnd';
import {
    SidebarHeader,
    SidebarTitle,
    CloseButton,
    GlobalTodoList,
} from '../../styles/Dashboard.styles';
import styled from 'styled-components';

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    overflow: auto;
`;

function DashboardSidebar({
    isSidebarOpen,
    setIsSidebarOpen,
    globalTodos,
    handleGlobalTodoOperations
}) {
    const ModalContent = styled.div`
        background: rgba(0, 0, 0, 0.6);
        border-radius: 8px;
        width: 100%;
        // padding: 8px;
        max-width: 480px;
        max-height: 90vh;
        overflow: hidden;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
        overflow-y: auto;

        @media (max-width: 768px) {
            max-width: 100%;
            border-radius: 0;
            height: 100%;
            max-height: 100%;
        }

        /* Webkit browsers (Chrome, Safari) */
        &::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }

        &::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.05);
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.2);
            border-radius: 4px;
            
            &:hover {
                background: rgba(255, 255, 255, 0.3);
            }
        }

        /* Firefox */
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
    `;
    return (
        <ModalOverlay onClick={() => setIsSidebarOpen(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                    <SidebarHeader>
                        <SidebarTitle></SidebarTitle>
                        <CloseButton
                            onClick={() => setIsSidebarOpen(false)}
                            title="Close todo list"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </CloseButton>
                    </SidebarHeader>
                    <DragDropContext onDragEnd={(result) => {
                        const { destination, source } = result;
                        if (!destination || 
                            (destination.droppableId === source.droppableId && 
                             destination.index === source.index)) {
                            return;
                        }
                        
                        // Since TodoList might be filtered, we need to map indices
                        // But for simplicity, we'll pass the result as is for now
                        // Ideally, TodoList should handle this internally or expose filter state
                        handleGlobalTodoOperations.reorder(result);
                    }}>
                        <GlobalTodoList
                            todos={globalTodos}
                            onAddTodo={handleGlobalTodoOperations.add}
                            onToggleTodo={handleGlobalTodoOperations.toggle}
                            onDeleteTodo={handleGlobalTodoOperations.delete}
                            onUpdateTodo={(index, newText) => handleGlobalTodoOperations.update(index, { text: newText })}
                            title="Ideas"
                            placeholder="What's on your mind?"
                        />
                    </DragDropContext>
            </ModalContent>
        </ModalOverlay>
    );
}

export default DashboardSidebar;
